import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import { withStyles, Card, CardHeader, CardContent, TextField, CardActionArea, Button, Typography, FormControl, Fade } from '@material-ui/core';
import Send from '@material-ui/icons/Send'

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white'

    },
    resize: {
        fontSize: 18
    },
    resizeLable: {
        fontSize: 15,
        fontWeight: 400
    },
    resize: {
        fontSize: 18
    },
    resizeLable: {
        fontSize: 15,
        fontWeight: 400
    },
    forgotCard: {
        width: 400,
        padding: '20px',
        boxShadow: 'none'
    },
    loginText: {
        fontSize: 25,
        fontWeight: 200
    },
    inputText: {
        padding: '15px',
        paddingLeft: '25px',
        border: 'solid thin #383838',
        borderTopLeftRadius: '30px',
        borderTopRightRadius: '30px',
        borderBottomLeftRadius: '30px',
        borderBottomRightRadius: '30px',
        backgroundColor: '#F9F9F9',
        marginBottom: '20px',
        outline: 'none'
    },
})

class FormOne extends Component {
    constructor(props) {
        super(props);

        this.state = {
            phone: '',
            date_of_birth: '',
        }

    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onSubmit = (e) => {
        e.preventDefault();

        this.props.setEmail(this.state.phone, this.state.date_of_birth);
    }

    render() {
        let { classes } = this.props;
        return (
            <div className={classes.container}>
                <Fade in={true} timeout={{ enter: 1500 }}>
                <form onSubmit={this.onSubmit}>
                    <Card className={classes.forgotCard}>
                        
                        <CardContent>

                            <div align="center">
                                <Typography
                                    className={classes.loginText}
                                    gutterBottom
                                >
                                    Forgot Password ?
                                </Typography>
                            </div>

                            <FormControl fullWidth required>
                            <label>Registered Mobile No</label>
                                <input
                                    required
                                    className={classes.inputText}
                                    name="phone"
                                    value={this.state.phone}
                                    onChange={this.handleChange}
                                    placeholder="Enter your Registered Mobile No"
                                />

                            </FormControl>

                            <FormControl fullWidth required>
                                <label>Date of Birth</label>
                                <input
                                    type="date"
                                    required
                                    className={classes.inputText}
                                    name="date_of_birth"
                                    value={this.state.date_of_birth}
                                    onChange={this.handleChange}
                                    placeholder="Date of Birth"
                                />

                            </FormControl>

                            <Typography variant="subtitle2" style={{ color: 'red' }}>{this.props.error}</Typography>

                            <div align="center">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    size="large"
                                    className={classes.button}
                                >
                                    Next
                                        </Button>
                            </div>

                        </CardContent>

                        <br />

                        <div align="center">
                            <Typography
                                variant="caption"
                            >
                                Go to home ? <b><Link to="/">Click Here</Link></b>
                            </Typography>

                        </div>

                        
                    </Card>
                </form>
                </Fade>

                
            </div>
        )
    }
}


export default withStyles(styles)(FormOne)